<template>
  <li class="dropdown messages-menu">
    <a href="javascript:;" class="dropdown-toggle" data-toggle="dropdown">
      <i class="fa fa-exclamation-triangle"></i>
      <span class="label label-warning">{{ qtfFalhas }}</span>
    </a>
    <ul class="dropdown-menu">
      <li class="header" v-if="idioma === 'DE'">{{ qtfFalhas }} Fehler wurden identifiziert</li>
      <li class="header" v-else-if="idioma === 'EN'">{{ qtfFalhas }} fault(s) were identified</li>
      <li class="header" v-else-if="idioma === 'ES'">Se identificaron {{ qtfFalhas }} fallas</li>
      <li class="header" v-else>Foram identificadas {{ qtfFalhas }} falha(s)</li>
      <li v-if="Falhas.length > 0">
        <!-- inner menu: contains the messages -->
        <ul class="menu">
          <message-item v-for="(message, key) in Falhas"
              :key="key"
              :message="message"></message-item>
        </ul>
        <!-- /.menu -->
      </li>
      <li class="footer" v-if="userInfo.messages.length > 0">
        <a href="javascript:;" v-if="idioma === 'DE'">Nah dran</a>
        <a href="javascript:;" v-else-if="idioma === 'EN'">Close</a>
        <a href="javascript:;" v-else-if="idioma === 'ES'">Cerrar</a>
        <a href="javascript:;" v-else>Fechar</a>
      </li>
    </ul>
  </li>
</template>

<script>
import { mapState } from 'vuex'
import MessageItem from './MessageItem'
import {firebaseApp} from '../../helpers/firebaseApp'
import config from '../../config'

var db = firebaseApp.database()

export default {
  name: 'MessagesMenu',
  components: {
    MessageItem
  },
  firebase: {
    registros: db.ref('sd032021')
  },
  data () {
    return {
      idioma: config.idioma,
      registros: []
    }
  },
  computed: {
    ...mapState([
      'userInfo'
    ]),
    Falhas () {
      let arrayFalhas = []
      this.registros.forEach(element => {
        if (element.is_alarme && element.valor !== 0) {
          arrayFalhas.push(element)
        }
      })
      return arrayFalhas
    },
    qtfFalhas () {
      return this.Falhas.length
    }
  }
}
</script>



// WEBPACK FOOTER //
// MessagesMenu.vue?6ee06d2d